import { render, staticRenderFns } from "./DashboardBuilder.vue?vue&type=template&id=3d790372&scoped=true&"
import script from "./DashboardBuilder.vue?vue&type=script&lang=js&"
export * from "./DashboardBuilder.vue?vue&type=script&lang=js&"
import style1 from "./DashboardBuilder.vue?vue&type=style&index=1&id=3d790372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d790372",
  null
  
)

export default component.exports